module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKCAYAAABv7tTEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIxJREFUeNpi+P//PwMhzPBQSwCILwBxAojPCBbEAxgfaQsAqQNArA8VCmQiUcNHIH7ARKIGh/9yVy8wQRUYAPEHIE4gpAEsD/Yk0Eog5ocqyAbiNFwawJrAoQGxYT4WV2JogGuCOgld4zcgtkbXAALwgABKLgBSc2FcIE7CpgEiixmR7UAcji+yAQIMAGUGgE/wp9u5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos-icons/bullet-dav-ok.png
// module id = 694
// module chunks = 1